import LocalizationService from "../../../services/localizationService";
import Person from "../../../models/person";
import { ScreenBase } from "@frui.ts/screens/dist";
import { attachAutomaticBlurValidator } from "utils/validationPatch";
import { computed, observable, reaction } from "mobx";
import { bound } from "@frui.ts/helpers";

export default abstract class PersonViewModel extends ScreenBase {
  private unsubscriptions: Array<() => void> = [];
  @observable phoneNumberChanged = false;

  @computed
  get defaultPrefixNumber() {
    if (!this.phoneNumberChanged) {
      return this.localizationService.defaultPrefixNumber;
    }
    return undefined;
  }

  @computed
  get datePickerLocalization() {
    return this.localizationService.datePickerLocalization;
  }

  constructor(public person: Person, protected localizationService: LocalizationService) {
    super();
    this.attachValidators();
  }

  protected onInitialize() {
    this.unsubscriptions.push(reaction(() => this.person.phoneNumber, this.onPhoneNumberChanged));
    super.onInitialize();
  }

  protected onDeactivate(isClosing: boolean): Promise<any> | void {
    if (isClosing) {
      this.unsubscriptions.forEach(unsubscribe => unsubscribe());
      this.unsubscriptions = [];
    }
    return super.onDeactivate(isClosing);
  }

  @bound
  onPhoneNumberChanged() {
    this.phoneNumberChanged = true;
  }

  translateGeneral(code: string, size?: number) {
    return this.localizationService.translateGeneral(code, size);
  }

  translateAttribute(model: string, attribute: string) {
    return this.localizationService.translateAttribute(model, attribute);
  }

  protected attachValidators() {
    attachAutomaticBlurValidator(this.person, this.person.rules);
  }
}
